export function cookies() {
  const parse = () => {
    const pairs = document.cookie.split("; ");
    const result: Record<string, string> = {};

    for (const pair of pairs) {
      const [key, ...rest] = pair.split("=");
      if (!key) continue;
      result[decodeURIComponent(key)] = decodeURIComponent(rest.join("="));
    }

    return result;
  };

  return {
    get: (name: string) => {
      const all = parse();
      return name in all ? { name, value: all[name] } : undefined;
    },
    getAll: () => {
      const all = parse();
      return Object.entries(all).map(([name, value]) => ({ name, value }));
    },
    has: (name: string) => {
      const all = parse();
      return name in all;
    },
  };
}